import styled from '@emotion/styled'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ColumnFlex } from '../../Layout/Layout'
import { Text } from '../../Typography/Typography'

const TextContainer = styled(Text)`
  padding: 16px;
`

const ShortSearchWord: FC = () => {
  const { t } = useTranslation()

  return (
    <ColumnFlex>
      <TextContainer $font-size={300} tabIndex={0}>
        {t('component.search.shortSearchWord')}
      </TextContainer>
    </ColumnFlex>
  )
}

export default ShortSearchWord
